import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";

var TaskMessages =
/*#__PURE__*/
function () {
  function TaskMessages() {
    _classCallCheck(this, TaskMessages);
  }

  _createClass(TaskMessages, null, [{
    key: "CreateNewTaskMessage",
    value: function CreateNewTaskMessage(message, taskId, taskName, url, projectId, notifyUserId) {
      return axios.post("/TaskMessage/CreateNewTaskMessage", {
        TaskId: taskId,
        Message: message,
        TaskName: taskName,
        URL: url,
        ProjectId: projectId,
        NotifyUserId: notifyUserId
      });
    }
  }, {
    key: "GetAllPropertiesNewTaskMessageCount",
    value: function GetAllPropertiesNewTaskMessageCount(task) {
      return axios.get("/TaskMessage/GetAllPropertiesNewTaskMessageCount", {
        params: {
          taskName: task
        },
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetPropertiesNewTaskMessageCount",
    value: function GetPropertiesNewTaskMessageCount(propertyId, task) {
      return axios.get("/TaskMessage/GetPropertiesNewTaskMessageCount", {
        params: {
          propertyId: propertyId,
          taskName: task
        },
        doNotShowLoading: true
      });
    }
  }, {
    key: "GetTaskMessages",
    value: function GetTaskMessages(taskId, task) {
      return axios.get("/TaskMessage/GetTaskMessages", {
        params: {
          taskId: taskId,
          taskName: task
        },
        doNotShowLoading: true
      });
    }
  }, {
    key: "ReadMessage",
    value: function ReadMessage(messageId, userId) {
      return axios.post("/TaskMessage/ReadMessage", {
        TaskMessageId: messageId,
        userId: userId,
        doNotShowLoading: true
      });
    }
  }]);

  return TaskMessages;
}();

export { TaskMessages as default };